<body>
    <div class="title container flex-center">
        <h1>Jeux vidéo</h1>
    </div>
    
    <div class="card-deck" fxLayout="row wrap" fxLayoutGap="10px grid">
        <div fxFlex="33%" fxFlex.lt-sm="100%" fxFlex.md="50%" fxFlex.sm="50%" fxLayoutAlign="center start" *ngFor="let game of gameList; let i = index">
            <!-- Card -->
            <app-project [projectData]="game"></app-project>
        </div>
    </div>

    <div class="title container flex-center">
        <h1>Logiciels</h1>
    </div>

    <div class="card-deck" fxLayout="row wrap" fxLayoutGap="10px grid">
        <div fxFlex="33%" fxFlex.lt-sm="100%" fxFlex.md="50%" fxFlex.sm="50%" fxLayoutAlign="center start" *ngFor="let software of softwareList; let i = index">
            <!-- Card -->
            <app-project [projectData]="software"></app-project>
        </div>
    </div>
</body>